import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useVendorAuth } from "../../store/vendorAuthStore";
import "./auth.css";

const API_BASE = "https://xiadot.com/vendor_api";

export default function VendorLogin() {
  const navigate = useNavigate();
  const { login } = useVendorAuth();

  const [phone,    setPhone]    = useState("");
  const [password, setPassword] = useState("");
  const [loading,  setLoading]  = useState(false);
  const [err,      setErr]      = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setErr("");

    if (!phone || phone.length !== 10) {
      setErr("Enter a valid 10-digit mobile number.");
      return;
    }
    if (!password) {
      setErr("Enter your password.");
      return;
    }

    try {
      setLoading(true);

      const response = await fetch(`${API_BASE}/vendor/auth/login.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ phone, password }),
      });

      const text = await response.text();
      console.log("RAW RESPONSE:", text);

      let data;
      try {
        data = JSON.parse(text);
      } catch (e) {
        console.error("Not JSON:", text);
        setErr("Server error. Try again.");
        return;
      }

      if (data.status === "success") {
        // ✅ Call store login — saves vendor_me to localStorage
        // so all pages using useVendorAuth() get vendor.id correctly
        login({
          token: data.token,
          data: {
            id:          data.user.id,
            vendor_id:   data.user.id,
            name:        data.user.name,
            owner_name:  data.user.name,
            phone:       data.user.phone,
            is_approved: data.user.is_approved ?? 1,
          },
        });

        navigate("/dashboard");
      } else {
        setErr(data.message || "Login failed.");
      }
    } catch (error) {
      setErr("Server error. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="vl-page">

      {/* LEFT SIDE */}
      <div className="vl-left">
        <div className="vl-left-glow-1" />
        <div className="vl-left-glow-2" />
        <div className="vl-left-top">
          <div className="vl-logo">
            <div className="vl-logo-icon">
              <img src={process.env.PUBLIC_URL + "/logo.png"} alt="Yuro Shopy" />
            </div>
            <span className="vl-logo-name">YURO SHOPY</span>
          </div>
        </div>
        <div className="vl-left-mid">
          <div className="vl-left-tag">Vendor Portal</div>
          <h1 className="vl-left-h1">Welcome<br /><em>back!</em></h1>
          <p className="vl-left-p">
            Sign in to manage your products, track orders, handle payouts and grow your business.
          </p>
        </div>
      </div>

      {/* RIGHT SIDE */}
      <div className="vl-right">
        <div className="vl-card">
          <div className="vl-card-label">Sign In</div>
          <h2 className="vl-card-title">Login to your account</h2>
          <p className="vl-card-sub">Enter your mobile number and password</p>

          {err && <div className="vl-error">{err}</div>}

          <form onSubmit={handleLogin}>

            {/* MOBILE */}
            <div className="vl-field">
              <label className="vl-lbl">Mobile Number</label>
              <div className="vl-iw">
                <span className="vl-ii">📞</span>
                <span style={{
                  position: "absolute", left: 40, top: "50%",
                  transform: "translateY(-50%)", fontSize: 14,
                  color: "#64748b", fontWeight: 600
                }}>+91</span>
                <input
                  className="vl-inp"
                  style={{ paddingLeft: 68 }}
                  type="tel"
                  value={phone}
                  onChange={(e) =>
                    setPhone(e.target.value.replace(/\D/g, "").slice(0, 10))
                  }
                  placeholder="Enter 10-digit number"
                  required
                />
              </div>
            </div>

            {/* PASSWORD */}
            <div className="vl-field">
              <label className="vl-lbl">Password</label>
              <div className="vl-iw">
                <span className="vl-ii">🔒</span>
                <input
                  className="vl-inp"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter password"
                  required
                />
              </div>
            </div>

            <button className="vl-btn" type="submit" disabled={loading}>
              {loading ? "Logging in..." : "Login →"}
            </button>

          </form>

          <div className="vl-footer">
            Don't have an account? <Link to="/register">Sign up</Link>
          </div>
          <div className="vl-footer" style={{ marginTop: 8 }}>
            <Link to="/forgot-password">Forgot Password?</Link>
          </div>
        </div>
      </div>
    </div>
  );
}